import {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  Wechat,
} from '@hb/mbridge';
import { isWeixin } from '../env/env';
import { getWeixinSign } from './openIdApi';

let sdkPromise: Promise<void> | null = null;
let configPromise: Promise<void> | null = null;

if (isWeixin) {
  const sdkRawPromise = new Wechat.Wechat().loadJSSDKScript();
  sdkPromise = sdkRawPromise
    .then(() => true)
    .catch(() => false);
  configPromise = new Promise(async (resolve, reject) => {
    try {
      const [{
        data: {
          timestamp,
          nonceStr,
          signature,
        },
      }] = await Promise.all([
        getWeixinSign(window.location.href.split('#')[0]),
        sdkRawPromise,
      ]);
      window.wx.ready(resolve);
      window.wx.error(reject);
      window.wx.config({
        debug: false,
        appId: 'wxb2315cf308c9a24d',
        timestamp,
        nonceStr,
        signature,
        jsApiList: [
          'onMenuShareAppMessage',
          'onMenuShareTimeline',
        ],
      });
    } catch (e) {
      reject(e);
    }
  });
}

export const invoke = async (cb: (wx: any) => void) => {
  if (await sdkPromise) {
    cb(window.wx);
  }
};

export const invokeJS = async (methodName: string, ...args: any[]) => {
  await configPromise;
  window.wx[methodName](...args);
};
